import { type Type } from '@angular/core';

import { AppointmentCard } from '@shared/components/appointment-card/appointment-card';
import { Avatar } from '@shared/components/avatar/avatar';
import { AvatarCard } from '@shared/components/avatar-card/avatar-card';
import { Button } from '@shared/components/button/button';
import { CalloutCard } from '@shared/components/callout-card/callout-card';
import { CaptureCard } from '@shared/components/capture-card/capture-card';
import { Carousel } from '@shared/components/carousel/carousel';
import { Chip } from '@shared/components/chip/chip';
import { ConsentIframe } from '@shared/components/consent-iframe/consent-iframe';
import { DatePicker } from '@shared/components/date-picker/date-picker';
import { DaySwitcher } from '@shared/components/day-switcher/day-switcher';
import { DetailCard } from '@shared/components/detail-card/detail-card';
import { DetailExpandableCard } from '@shared/components/detail-expandable-card/detail-expandable-card';
import { DigitalCredentialCard } from '@shared/components/digital-credential-card/digital-credential-card';
import { Disclaimer } from '@shared/components/disclaimer/disclaimer';
import { DynamicText } from '@shared/components/dynamic-text/dynamic-text';
import { Feedback } from '@shared/components/feedback/feedback';
import { FilterChip } from '@shared/components/filter-chip/filter-chip';
import { GoalCard } from '@shared/components/goal-card/goal-card';
import { HeightInput } from '@shared/components/height-input/height-input';
import { IconButton } from '@shared/components/icon-button/icon-button';
import { Image } from '@shared/components/image/image';
import { ImageButton } from '@shared/components/image-button/image-button';
import { InfoBanner } from '@shared/components/info-banner/info-banner';
import { InfoListCard } from '@shared/components/info-list-card/info-list-card';
import { InfoStatsCard } from '@shared/components/info-stats-card/info-stats-card';
import { LabResultCard } from '@shared/components/lab-result-card/lab-result-card';
import { ListMenu } from '@shared/components/list-menu/list-menu';
import { NotificationCard } from '@shared/components/notification-card/notification-card';
import { OverlaySplash } from '@shared/components/overlay-splash/overlay-splash';
import { PaymentCard } from '@shared/components/payment-card/payment-card';
import { PaymentFailure } from '@shared/components/payment-failure/payment-failure';
import { PharmacyTaskCard } from '@shared/components/pharmacy-task-card/pharmacy-task-card';
import { ProcessStatusCard } from '@shared/components/process-status-card/process-status-card';
import { ProfileSelector } from '@shared/components/profile-selector/profile-selector';
import { ProgramAddressTaskCard } from '@shared/components/program-address-task-card/program-address-task-card';
import { ProgressBar } from '@shared/components/progress-bar/progress-bar';
import { RecommendationCard } from '@shared/components/recommendation-card/recommendation-card';
import { RowButton } from '@shared/components/row-button/row-button';
import { ScheduledVisitCard } from '@shared/components/scheduled-visit/scheduled-visit-card';
import { SelectionButton } from '@shared/components/selection-button/selection-button';
import { SelectionRow } from '@shared/components/selection-row/selection-row';
import { Skeleton } from '@shared/components/skeleton/skeleton';
import { SnapshotCard } from '@shared/components/snapshot-card/snapshot-card';
import { StepOverviewCard } from '@shared/components/step-overview-card/step-overview-card';
import { SummaryCard } from '@shared/components/summary-card/summary-card';
import { SvgIcon } from '@shared/components/svg-icon/svg-icon';
import { Tabs } from '@shared/components/tabs/tabs';
import { TaskCard } from '@shared/components/task-card/task-card';
import { TimeBadge } from '@shared/components/time-badge/time-badge';
import { VisitCard } from '@shared/components/visit-card/visit-card';
import { VisitStatusCard } from '@shared/components/visit-status-card/visit-status-card';
import { WalletButton } from '@shared/components/wallet-button/wallet-button';
import { WeightInput } from '@shared/components/weight-input/weight-input';

import { type ComponentType } from './component-type';

export const COMPONENT_DEFINITIONS: Record<ComponentType, Type<unknown>> = {
  AppointmentCard: AppointmentCard,
  AvatarCard: AvatarCard,
  Avatar: Avatar,
  Button: Button,
  CalloutCard: CalloutCard,
  Carousel: Carousel,
  CaptureCard: CaptureCard,
  Chip: Chip,
  ConsentIframe: ConsentIframe,
  DatePicker: DatePicker,
  DaySwitcher: DaySwitcher,
  DetailCard: DetailCard,
  DetailExpandableCard: DetailExpandableCard,
  Disclaimer: Disclaimer,
  FilterChip: FilterChip,
  Feedback: Feedback,
  GoalCard: GoalCard,
  IconButton: IconButton,
  Image: Image,
  InfoBanner: InfoBanner,
  InfoListCard: InfoListCard,
  InfoStatsCard: InfoStatsCard,
  LabResultCard: LabResultCard,
  ListMenu: ListMenu,
  WeightInput: WeightInput,
  HeightInput: HeightInput,
  DigitalCredentialCard: DigitalCredentialCard,
  NotificationCard: NotificationCard,
  OverlaySplash: OverlaySplash,
  ProcessStatusCard: ProcessStatusCard,
  ProfileSelector: ProfileSelector,
  ProgressBar: ProgressBar,
  RowButton: RowButton,
  SelectionButton: SelectionButton,
  SelectionRow: SelectionRow,
  Skeleton: Skeleton,
  SnapshotCard: SnapshotCard,
  StepOverviewCard: StepOverviewCard,
  SvgIcon: SvgIcon,
  Tabs: Tabs,
  TimeBadge: TimeBadge,
  DynamicText: DynamicText,
  VisitCard: VisitCard,
  TaskCard: TaskCard,
  VisitStatusCard: VisitStatusCard,
  SummaryCard: SummaryCard,
  ImageButton: ImageButton,
  RecommendationCard: RecommendationCard,

  // Smart components (including logic)
  WalletButton: WalletButton,
  ScheduledVisitCard: ScheduledVisitCard,
  PaymentCard: PaymentCard,
  PaymentFailure: PaymentFailure,
  PharmacyTaskCard: PharmacyTaskCard,
  ProgramAddressTaskCard: ProgramAddressTaskCard,
};
